<!-- Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
  NVIDIA CORPORATION and its licensors retain all intellectual property
 and proprietary rights in and to this software, related documentation
 and any modifications thereto.  Any use, reproduction, disclosure or
 distribution of this software and related documentation without an express
 license agreement from NVIDIA CORPORATION is strictly prohibited.
  -->

<!-- Attempting to remove fxLayout causes issues with nv-app-bar which appears to require a parent container with fxLayout -->
<div class="app-container" fxLayout="column" fxFlex="auto" fxFlexAlign="start center">
    <nv-app-bar class="appbar" [logoBehavior]="AppBarLogoBehavior.NoShow" skipTour="true"></nv-app-bar>
    <main class="app-content">
        <router-outlet></router-outlet>
    </main>
    <nv-common-footer></nv-common-footer>
</div>
